import style from "css/todayReservation.module.css";
import { useEffect, useRef } from 'react';

import { Empty, Spin } from 'antd';
import { ReactComponent as RightArrow } from "asset/calendar/next.svg";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import HotdeskingCard from './component/hotdeskingCard';
import MeetingRoomCard from './component/MeetingRoomCard';

function ReservationDetail({ hotdeskingScheduleList, meetingScheduleList, type, isLoading }) {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    // hotdesking 가로 스크롤
    const hotdeskingScrollRef = useRef();

    useEffect(() => {
        const handleWheel = (e) => {
            if (!hotdeskingScrollRef.current) return;
            e.preventDefault(); // 수직 스크롤 방지
            hotdeskingScrollRef.current.scrollLeft += e.deltaY; // 가로 스크롤 적용
        };

        const el = hotdeskingScrollRef.current;
        if (el) el.addEventListener("wheel", handleWheel);

        return () => {
            if (el) el.removeEventListener("wheel", handleWheel);
        };
    }, []);

    return (
        <div className={style.todayRes_container}>
            <div className={style.hotdesking}>
                <div className={style.header}>
                    <div className={style.left}>
                        {t("LABEL.TITLE.HOTDESKING_STATUS")}
                        <div className={style.status_circle}>{hotdeskingScheduleList.length}</div>
                    </div>
                    <div className={style.right} onClick={() => navigate(`${process.env.REACT_APP_CLIENT_URL}app/hotdesking`)}>
                        {i18n.language === 'ko-KR' ? <>Hot Desking <span>바로가기</span></> : <>Go to <span>Hot Desking</span></>}
                        <RightArrow />
                    </div>
                </div>
                <div ref={hotdeskingScrollRef} className={style.content}>
                    {
                        isLoading.hotdesking ?
                            <div style={{ height: "115px", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Spin size='large' />
                            </div>
                            :
                            hotdeskingScheduleList.length > 0
                                ?
                                <div className={style.card_list}>
                                    {hotdeskingScheduleList.map((schedule, idx) => {
                                        return (
                                            <HotdeskingCard
                                                key={schedule.id}
                                                idx={idx + 1}
                                                total={hotdeskingScheduleList.length}
                                                schedule={schedule}
                                                type={type}
                                            />
                                        )
                                    })}
                                </div>
                                :
                                <div style={{ height: "115px", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                </div>
                    }
                </div>
            </div>
            <div className={style.meetingroom}>
                <div className={style.header}>
                    <div className={style.left}>
                        {t("LABEL.TITLE.MEETINGROOM_STATUS")}
                        <div className={style.status_circle}>{meetingScheduleList.length}</div>
                    </div>
                    <div className={style.right} onClick={() => navigate(`${process.env.REACT_APP_CLIENT_URL}app/meeting/room`)}>
                        {i18n.language === 'ko-KR' ? <>회의실 <span>바로가기</span></> : <>Go to <span>Meeting Room</span></>}
                        <RightArrow />
                    </div>

                </div>
                <div className={style.content}>
                    <div className={style.meetingroom_table_container}>
                        <div className={style.header}>
                            {type !== "Today" && <div className={style.col_0}>{t("LIST.RESERVE_DATE")}</div>}
                            <div className={style.col_1}>{t("LIST.RESERVE_TIME")}</div>
                            <div className={style.col_2}>{t("LIST.MEETING_ROOM")}</div>
                            <div className={style.col_3} style={{ width: type === "Today" ? "46%" : "28%" }}>{t("LIST.TITLE")}</div>
                            <div className={style.col_4}>{t("LIST.PARTICIPANT")}</div>
                        </div>
                        {
                            isLoading.meeting
                                ?
                                <div style={{ height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <Spin size='large' />
                                </div>
                                :
                                meetingScheduleList.length > 0
                                    ?
                                    <div className={style.list_wrapper}>
                                        <div className={style.list_container}>
                                            {
                                                meetingScheduleList.map(schedule => (
                                                    <MeetingRoomCard
                                                        schedule={schedule}
                                                        type={type}
                                                        key={schedule.id}
                                                    />
                                                ))
                                            }
                                        </div>
                                    </div>
                                    :
                                    <div style={{ height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                    </div>
                        }
                    </div>
                </div>

            </div>
        </div>
    )
}

export default ReservationDetail